import { render } from "./IdIcon.vue?vue&type=template&id=6cfc709b"
const script = {}
script.render = render

export default script